/* eslint-disable semi */
/* eslint-disable comma-dangle */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Avatar } from 'antd'
import { Fragment } from 'react'
import { Coffee } from 'react-feather'
import { Slide, toast } from 'react-toastify'

// ** Axios Imports
import baseurl from '../../../@core/auth/jwt/baseurl'
import emiter from '../../../utility/hooks/emiiter'

const showErrorMsg = (error) => {
  toast.error(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Error</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{error}</span>
      </div>
    </Fragment>,
    {
      icon: false,
      transition: Slide,
      hideProgressBar: false,
      autoClose: 2000
    }
  )
}

export const getData = createAsyncThunk(
  'appNationallistCategories/getData',
  async (params) => {
    const response = await baseurl.get('/api/app/nationallist-category', {
      params
    })
    return {
      params,
      data: response.data.items,
      totalPages: response.data.totalCount
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const getTree = createAsyncThunk(
  'appNationallistCategories/getData',
  async (params) => {
    const response = await baseurl.get('/api/app/nationallist-category/tree', {
      params
    })
    return {
      params,
      data: response.data
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const addCategory = createAsyncThunk(
  'appNationallistCategories/addCategory',
  async (category, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.post('/api/app/nationallist-category', category, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        emiter.emit('close-category-create-popup')
        await dispatch(getTree(getState().nationallistcategories.params))
        return category
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updateCategory = createAsyncThunk(
  'appNationallistCategories/updateCategory',
  async (category, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.put(`/api/app/nationallist-category/${category.id}`, category, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        emiter.emit('close-category-create-popup')
        await dispatch(getTree(getState().nationallistcategories.params))
        return category
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const deleteCategory = createAsyncThunk(
  'appNationallistCategories/deleteCategory',
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.delete(`/api/app/nationallist-category/${id}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 204) {
        emiter.emit('close-category-delete-popup')

        await dispatch(getTree(getState().nationallistcategories.params))
        return id
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const appNationallistCategoriesSlice = createSlice({
  name: 'appNationallistCategories',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    loading: true,
    saveLoading: false,
    saveSuccess: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTree.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.loading = false
      })
      .addCase(getTree.pending, (state) => {
        state.loading = true
      })
      .addCase(getTree.rejected, (state) => {
        state.loading = false
      })
      .addCase(addCategory.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(addCategory.rejected, (state) => {
        state.saveLoading = false
        state.saveSuccess = false
      })
      .addCase(addCategory.fulfilled, (state) => {
        state.saveLoading = false
        state.saveSuccess = true
      })

      .addCase(updateCategory.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(updateCategory.rejected, (state) => {
        state.saveLoading = false
        state.saveSuccess = false
      })
      .addCase(updateCategory.fulfilled, (state) => {
        state.saveLoading = false
        state.saveSuccess = true
      })

      .addCase(deleteCategory.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(deleteCategory.rejected, (state) => {
        state.saveLoading = false
        state.saveSuccess = false
      })
      .addCase(deleteCategory.fulfilled, (state) => {
        state.saveLoading = false
        state.saveSuccess = true
      })
  }
})

export default appNationallistCategoriesSlice.reducer
